import { Product } from "@/shared/domains";
import type { Coupon, Price, Subscription } from "@/shared/domains";
import { parseResponseData, privateAPI } from "@/shared/lib";

export const getSubscriptionProductWithAvailableHigherPrices = async (
  subscriptionId: Subscription["id"],
) => {
  const response = await privateAPI.get(
    `patients/subscriptions/${subscriptionId}/available-higher-prices`,
  );

  return parseResponseData(response, Product);
};

interface UpgradeSubscriptionParams {
  subscriptionId: Subscription["id"];
  productPriceId: Price["id"];
  couponCode?: Coupon["code"];
}

export const upgradeSubscription = async ({
  subscriptionId,
  ...params
}: UpgradeSubscriptionParams) => {
  return await privateAPI.post(
    `patients/subscriptions/${subscriptionId}/upgrade`,
    params,
  );
};
